import { InitialiseData } from 'src/app/models/state.model'

export interface InitializeState extends InitialiseData {}

export const initialInitializeState: InitializeState = {
  selectedCompanies: undefined,
  user: undefined,
  taskTypes: undefined,
  relatedCompanies: undefined,
  uiStatusMapping: undefined,
  options: undefined,
  relatedLocations: undefined,
  screenConfigs: undefined,
  userAuthType: undefined,
  enabledModules: [],
  enabledCategories: []
}
